import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) {
  }

  createDashboard(body: any) {
    return this.http.post('/api/dashboard/', body);
  }

  fetchDashBoards() {
    return this.http.get('/api/dashboard/');
  }

  updateDashboard(id: number, payload: any) {
    return this.http.patch(`/api/dashboard/${id}/`, payload);
  }

  deleteDashboard(id: number) {
    return this.http.delete(`/api/dashboard/${id}/`);
  }
}
